import React from 'react'

type DefaultUserIconFilledProps = { width?: string; height?: string }

function DefaultUserIconFilled({
  width = '60',
  height = '60',
}: DefaultUserIconFilledProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 60 60'
      fill='none'
    >
      <rect
        width='60'
        height='60'
        rx='14'
        fill='#6267AC'
      />
      <path
        d='M21 38C23.3358 35.5226 26.507 34 30 34C33.493 34 36.6642 35.5226 39 38M34.5 25.5C34.5 27.9853 32.4853 30 30 30C27.5147 30 25.5 27.9853 25.5 25.5C25.5 23.0147 27.5147 21 30 21C32.4853 21 34.5 23.0147 34.5 25.5Z'
        stroke='#F3F3F3'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default DefaultUserIconFilled
